import { defineComponent as _defineComponent } from 'vue'
import { useGetComponentName } from '~/composables/useGetComponentName';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import BlockEnumerationStandard from '~/components/cms/custom/BlockEnumeration/BlockEnumerationStandard.vue';

import type { ConfigDisplayOptions } from '@az/middleware/src/__generated__/gql/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockEnumeration',
  props: {
    title: null,
    items: { default: () => [] },
    displayOptions: { default: () => [] },
    catchphrase: null,
    tabCatchphrase: null,
    note: null,
    description: null
  },
  setup(__props: any) {

const props = __props as { title?: string, items: unknown[], displayOptions: ConfigDisplayOptions[], catchphrase?: string, tabCatchphrase?: string, note?: unknown, description?: string };

const BlockEnumerationPhased = () => import('~/components/cms/custom/BlockEnumeration/BlockEnumerationPhased.vue');
const BlockEnumerationBigNumber = () =>
  import('~/components/cms/custom/BlockEnumeration/BlockEnumerationBigNumber.vue');



const componentName = useGetComponentName(
  {
    'standard': BlockEnumerationStandard,
    'phased': BlockEnumerationPhased,
    'big-number': BlockEnumerationBigNumber,
  },
  props.displayOptions,
);
const classes = useGetDisplayOptionsClasses(props.displayOptions);

return { __sfc: true,BlockEnumerationPhased, BlockEnumerationBigNumber, props, componentName, classes }
}

})